<template>
  <td class="text-center text-lg">
    <default-null-html v-if="!content" />
    <div v-else class="ping" :class="quality" :title="pingString"></div>
  </td>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";

export default {
  components: {
    defaultNullHtml
  },
  props: ["content"],
  computed: {
    quality() {
      if (this.content < 50) {
        return ["ping--good"];
      } else if (this.content < 150) {
        return ["ping--middle"];
      } else {
        return ["ping--bad"];
      }
    },
    pingString() {
      return `${this.content} ms`;
    }
  }
};
</script>

<style scoped lang="scss">
.ping {
  border-radius: 100%;
  background-color: #cacaca;
  transition: background-color 0.3s linear;
  height: 25px;
  width: 25px;
  margin-left: 10px;

  &--good {
    background-color: $green;
  }
  &--middle {
    background-color: $yellow;
  }
  &--bad {
    background-color: $red;
  }
}
</style>
